import { put, call, select } from "redux-saga/effects"
import * as actions from "../action_creators"
import * as client from "../../api/client"
import { getProfile, getAccount } from "../selectors"
import { handleAlert } from "./alert_sagas"
import { alerts } from "../../util/alert_error_utils"

export function* handleUpdateAccountName({ companyName }) {
    const profile = yield select(getProfile)

    if (!profile) return

    const meta = {
        id: profile.accountId,
        name: companyName,
    }

    try {
        const resp = yield call(client.patchAccounts, meta)
        if (resp === undefined) {
            yield put(actions.setAlerts("failProfileUpdate", ""))
            return
        }

        // rename variable of name response string
        const { name } = resp
        const account = yield select(getAccount, profile.accountId)

        // update local state accounts
        yield put(actions.receiveAccounts({ ...account, name }))

        if (profile.onboardingStep === "done") {
            // set alert
            yield put(actions.setAlerts("successAccountUpdate", ""))
        }
    } catch (e) {
        yield put(actions.setAlerts("failAccountUpdate", ""))
        return
    }
}

export function* handleResendVerificationCode() {
    const email = localStorage.getItem("email")
    try {
        const resp = yield call(client.resendVerification)
        if (resp === undefined) {
            yield put(actions.setAlerts("failResendVerification", ""))
            return
        }
        yield call(handleAlert, {
            alert: alerts["successResendVerification"],
            vars: email,
        })
    } catch (e) {
        yield put(actions.setAlerts("failResendVerification", ""))
        return
    }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/account_sagas.js